// extracted by mini-css-extract-plugin
module.exports = {"timePeriodTypeSelector":"TimePeriodTypeSelector_timePeriodTypeSelector__2MfNJ","title":"TimePeriodTypeSelector_title__17ryd"};